import { useEffect } from "react";

const positions = [
  { id: "circle1", letter: "U", style: { bottom: "20px", left: "209px" } },
  { id: "circle2", letter: "I", style: { bottom: "20px", right: "206px" } },
  { id: "circle3", letter: "T", style: { top: "82px", right: "25px" } },
  { id: "circle4", letter: "B", style: { top: "82px", left: "27px" } },
];

export default function NeonFlickerCircles() {
  useEffect(() => {
    const flickerCircle = () => {
      const random = positions[Math.floor(Math.random() * positions.length)].id;
      const elem = document.getElementById(random);
      if (!elem) return;

      // neon flicker sequence 
      const flicks = [
        { opacity: 1, },
        { opacity: 0.6, },
        { opacity: 1,  },
        { opacity: 0.8,  },
        { opacity: 1,  },
      ];

      flicks.forEach((style, i) => {
        setTimeout(() => {
          Object.assign(elem.style, style);
        }, i * 250);
      });

      // reset
      setTimeout(() => {
        elem.style.opacity = "1";
      }, flicks.length * 250);
    };

    const interval = setInterval(flickerCircle, 300);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      {positions.map((pos) => (
        <div
          key={pos.id}
          id={pos.id}
          style={{
            position: "fixed",
            width: "30px",
            height: "30px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#b6b1b1ff", // plain text
            zIndex: 10,
            opacity: 1,
            ...pos.style,
          }}
        >
          {pos.letter}
        </div>
      ))}
    </div>
  );
}
 